<template>
    <div class="automation-block-editor number-formatter-chain">
        <div class="editor-row customize-editor-minimize data-items">
            <div class="editor-row-title">{{ $t('auto.numberFormatChainNumberFormatChains') }}</div>
            <NumberFormatter
                v-model="clone.chains[index]"
                v-for="(item, index) in clone.chains"
                :key="index"
                @delete="() => deleteFormatter(index)"
                :blockId="blockId"
                :deleteEnabled="clone.chains.length > 1"
            />
        </div>
        <SupsisButton @click="addItem">
            <i class="material-icons">add</i>
            <span>{{ $t('auto.numberFormatChainAddNewFormatter') }}</span>
        </SupsisButton>
    </div>
</template>

<script>
import log2 from "../../../../../../../../utils/log2";
import _ from "lodash";
import SupsisButton from "../../../../../../Settings/components/SupsisButton.vue";
import NumberFormatter from "./NumberFormatter.vue";

const log = log2("NumberFormatterChain");
export default {
    name: "NumberFormatterChain",
    components: { NumberFormatter, SupsisButton },
    props: ["value", "blockId"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            chains: [],
        };
        return {
            clone,
        };
    },
    methods: {
        addItem() {
            this.clone.chains.push({
                mode: "math.add",
                values: [`{{block.${this.blockId}}}`, ""],
                options: {},
            });
        },
        deleteFormatter(index) {
            this.clone.chains.splice(index, 1);
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue, oldValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.automation-block-editor.number-formatter-chain {
    padding: 20px;
    display: flex;
    gap: 20px;
    flex-direction: column;

    .editor-row {
        width: 100%;
        border-bottom: 1px solid var(--color-border-default);

        &.customize-editor-minimize {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }

        small.description {
            font-size: 10px;
            color: var(--color-text-weak-default);
        }

        .editor-row-title {
            font-weight: bold;
            font-size: 16px;
        }
    }
}
</style>
